import React, { useEffect } from 'react';
import styled from 'styled-components';
import { useRouter } from 'next/router';

import { useTypedSelector } from '@/store/store';
import { selectDetailedCarData } from '@/store/reducers/detailed-car';
import CreditInformationButton from '@/components/CreditInformationButton';
import { useCreditModal } from '@/modules/DetailedCar/DetailedCar.hooks';

const Credit = () => {
  const data = useTypedSelector(selectDetailedCarData);
  const router = useRouter();

  const handleOpenCreditModal = useCreditModal();

  useEffect(() => {
    if (data?.actionsDisabled) {
      return;
    }

    if (router.query.calculatorOpened && data?.pricing?.minimalCreditPayment) {
      handleOpenCreditModal();
    }
  }, []);

  if (!data || data.actionsDisabled || !data?.pricing?.minimalCreditPayment) {
    return null;
  }

  return (
    <Component>
      {data.pricing.minimalCreditPayment ? (
        <CreditInformationButton
          type="credit"
          minMonthPayment={data.pricing.minimalCreditPayment}
          onClick={handleOpenCreditModal}
        />
      ) : null}
    </Component>
  );
};

export default Credit;

const Component = styled.div`
  > * {
    margin-top: 16px;
  }
`;
